import { z } from "zod";

export const signInInput = z.object({
  email: z.email("Bitte geben Sie eine gültige E-Mail-Adresse ein"),
  password: z.string().min(8, "Mindestens 8 Zeichen"),
});
export type SignInInput = z.infer<typeof signInInput>;

export const signUpInput = signInInput.extend({
  name: z.string().min(1, "Pflichtfeld"),
});
export type SignUpInput = z.infer<typeof signUpInput>;
